import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../utils/propUtils';
import VeltCommentsSidebarFilterName from '../VeltCommentsSidebarFilterName/VeltCommentsSidebarFilterName';
import VeltCommentsSidebarFilterItem from '../VeltCommentsSidebarFilterItem/VeltCommentsSidebarFilterItem';
var VeltCommentsSidebarFilterGroupBy = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-filter-group-by-wireframe", __assign({}, transformedProps), children));
};
VeltCommentsSidebarFilterGroupBy.Name = VeltCommentsSidebarFilterName;
VeltCommentsSidebarFilterGroupBy.Item = VeltCommentsSidebarFilterItem;
export default VeltCommentsSidebarFilterGroupBy;
